<script>
    import {M} from "../../external";

    export let data, onChange;

    let isChecked = data.isChecked || false;
    let isExcluded = data.isExcluded || false;
    let instance;

    function exclude() {
        isExcluded = !isExcluded;
        isChecked = isExcluded;
        onChange(data.id, isExcluded, isExcluded);
    }

    function change(e) {
        if (e.target.className === 'list-exclude') {
            return;
        }

        isChecked = !isChecked;
        isExcluded = (isChecked ? isExcluded : false);
        onChange(data.id, isChecked, isExcluded);
    }

</script>
<div bind:this={instance} class="email-list-wrapper flex align-center {isExcluded ? 'excluded-list' : ''}"
     on:click={change}>
    <div class="checkbox-wrapper small">
        <input id="{data.id}{data.name}" class="css-checkbox select-cbx" bind:checked={isChecked}
               type="checkbox" name="{data.id}{data.name}" on:change={change}/>
        <label for="{data.id}{data.name}" class="css-label">&nbsp;</label>
    </div>
    <h5 class="flex-1">{data.name}</h5>
    <div class="justify-flex-end">
        <span class="email-list-number">{data.subscribers || 0}</span>
        <a on:click={exclude} class="list-exclude">{isExcluded ? M.EXCLUDED : M.EXCLUDE}</a>
    </div>
</div>